import Title_ru_RU         from '@/core/misc/decorators/Title_ru_RU';
import serializeSimplified from "@/core/misc/decorators/SerializeSimplified";
import TYPES               from '@/core/services/Changelogs/types';

import BaseEntity          from '@/core/misc/BaseEntity';
import Core                from "@/core/Core";
import type TransportOrder from "@/domains/TransportOrders/TransportOrder";
import DateRange           from "@/core/types/DateRange";
import Sum                 from "@/core/types/Sum";
/**
 * Простой транспорта
 */
class TransportDowntime extends BaseEntity {

    static Events = {
        Created: 'transportDowntime:created',
        Updated: 'transportDowntime:updated',
        Deleted: 'transportDowntime:deleted',
    } as const;

    static REASON_PRESETS = [
        'Простоял в пробке',
        'Ожидание на разгрузке',
        'Поломка ТС',
        'Погодные условия',
    ] as const;

    /** Обратная ссылка на ЗТК */
    @serializeSimplified
    public transportOrder: { id: number } | TransportOrder;

    @Title_ru_RU('Период простоя', TYPES.DATE_RANGE)
    public period: DateRange;

    @Title_ru_RU('Стоимость простоя', TYPES.NUMBER)
    public cost: Sum;

    @Title_ru_RU('Валюта', TYPES.STRING)
    public currencyCode: string = Core.acl.currentPartnerCurrencyCode;

    @Title_ru_RU('Причина простоя', TYPES.STRING)
    public reason: string;

    // Поле для платёжного документа
    public paymentDocument: string;

    static isTransportDowntime(entity: unknown): entity is TransportDowntime {
        return entity instanceof TransportDowntime;
    }

    static fromServer(transportDowntimeData: any, downtime: TransportDowntime = new TransportDowntime()): TransportDowntime {
        super.fromServer(transportDowntimeData, downtime);

        downtime.period = Core.utils.hydrate(transportDowntimeData.period, DateRange.fromServer)!;
        downtime.cost   = Core.utils.hydrate(transportDowntimeData.cost, Sum.fromServer)!;

        return downtime;
    }

    static fromTransportOrder(transportOrderId: number): TransportDowntime {
        const downtime = new TransportDowntime();

        downtime.transportOrder = { id: transportOrderId };

        return downtime;
    }
}

export default TransportDowntime;
